import { render, staticRenderFns } from "./SnackBar-comp.vue?vue&type=template&id=37170983&scoped=true&"
import script from "./SnackBar-comp.vue?vue&type=script&lang=js&"
export * from "./SnackBar-comp.vue?vue&type=script&lang=js&"
import style0 from "./SnackBar-comp.vue?vue&type=style&index=0&id=37170983&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37170983",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCardText,VCardTitle,VIcon,VSpacer})
